import { warning as s } from "./atoms-v2886.js";
import { isGenerator as f } from "./atoms-v2889.js";
import { isAnimatable as l } from "./atoms-v21204.js";
function g(t) {
  const i = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== i)
      return !0;
}
function h(t, i, n, u) {
  const r = t[0];
  if (r === null)
    return !1;
  if (i === "display" || i === "visibility")
    return !0;
  const a = t[t.length - 1], e = l(r, i), o = l(a, i);
  return s(e === o, `You are trying to animate ${i} from "${r}" to "${a}". ${r} is not an animatable value - to enable this animation set ${r} to a value animatable to ${a} via the \`style\` property.`), !e || !o ? !1 : g(t) || (n === "spring" || f(n)) && u;
}
export {
  h as canAnimate
};
